/**
 * Background Video Setup
 * Initializes Shaka Player for HLS/DASH video streaming on landing pages
 */

/**
 * Initialize background videos that use HLS or DASH streaming
 * Falls back gracefully if Shaka Player fails to load
 */
export async function ensureBackgroundVideosInit() {
  try {
    const selector = 'video[data-hls-url], video[data-dash-url]';
    const videos = document.querySelectorAll(selector);
    
    // Check if any video needs initialization
    let needsInit = false;
    for (const video of videos) {
      if (video.dataset.shakaInitialized !== 'true') {
        needsInit = true;
        break;
      }
    }

    if (needsInit) {
      const mod = await import(/* webpackChunkName: "shaka_player" */ 'common/shaka_player');
      if (mod?.autoInitShaka) {
        mod.autoInitShaka();
      }
    }
  } catch (error) {
    // Silently fail - background videos are not critical
    console.debug('Background video init skipped:', error.message);
  }
}

/**
 * Setup auto-initialization on page load and Turbo navigation
 */
export function setupVideoListeners() {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureBackgroundVideosInit);
  } else {
    ensureBackgroundVideosInit();
  }
  
  document.addEventListener('turbo:load', ensureBackgroundVideosInit);
}

